import React from "react";
import classes from "./gallery.module.css";
import GalleryItemShimmer from "./item.shimmer";

const GalleryShimmer = (props) => {
  const { items, itemProps } = props;

  return (
    <div className={classes.root} aria-live="polite" aria-busy="true">
      <div className={classes.items}>
        {items.map((item, index) => (
          <GalleryItemShimmer key={index} {...itemProps} />
        ))}
      </div>
    </div>
  );
};

GalleryShimmer.defaultProps = {
  items: [],
  itemProps: {},
};

export default GalleryShimmer;
